import { ScheduleManagementPage } from "../../../components/schedule/ScheduleManagementPage";

export function AdminSchedulePage() {
  return <ScheduleManagementPage role="admin" />;
}
